/**
 * Enum for different chip types used in the system.
 * Each key represents a type of chip, and its corresponding value is a unique numeric identifier.
 *
 * @readonly
 * @enum {number}
 */
const ChipTypeEnums = Object.freeze({
	//Generic search chip type.
	Undefined: 0,

	//Defect status type filter
	DefectStatusType: 1,

	//Defect status ID filter
	DefectStatusID: 2,

	//Site department ID filter
	SiteDepartmentID: 3,

	//Defect risk rating filter.
	DefectRiskRatingID: 4,

	//Model filter.
	ModelID: 5,

	//System filter.
	DefectSystemID: 6,

	//Defect type filter.
	DefectTypeID: 7,

	//Notification status filter.
	NotificationRaised: 8,

	//Asset filter.
	SiteAssetID: 9,

	//Defect work order filter.
	DefectWorkOrder: 10,

	//Service work order filter.
	ServiceWorkOrder: 11,

	//Model Type Filter
	ModelTypeID: 12,

	//User Filter
	UserID: 13,

	//Model Status Filter
	ModelStatusID: 14,

	//Interval Filter
	Interval: 15,

	//Role Filter
	Role: 16,
});

/**
 * Enum for chip types that should be hidden.
 * Subset of ChipTypeEnums where these chip types are not displayed or handled differently in the UI.
 *
 * @readonly
 * @enum {number}
 */
const HiddenChipTypeEnums = Object.freeze({
	//Defect status type filter
	DefectStatusType: 1,

	//Defect status ID filter
	DefectStatusID: 2,

	// Site department ID filter
	// SiteDepartmentID: 3,

	//Model Type Filter
	// ModelTypeID: 12,
});
/**
 * Currently used chips in the Model List page
 * Each key represents a type of chip, and its corresponding value is a unique numeric identifier.
 *
 * @readonly
 * @enum {number}
 */
const ModelListChipTypeEnums = Object.freeze({
	//Generic search chip type.
	Undefined: 0,

	//Model filter.
	ModelID: 5,

	//Asset filter.
	SiteAssetID: 9,

	//Model Type Filter
	ModelTypeID: 12,

	//User Filter
	UserID: 13,

	//Model Status Filter
	ModelStatusID: 14,
});

export { ChipTypeEnums, HiddenChipTypeEnums, ModelListChipTypeEnums };
